// eslint-disable-next-line import/prefer-default-export
export const SLIDE_STYLE = {
  MULTI_BRAND_SLIDE: 'multi-brand',
  CAMPAIGN_BANNER_SLIDE: 'campaign-banner',
};
